import Seo from "@/components/Seo";

export default function Terms() {
  return (
    <article className="container-kore py-20 max-w-3xl">
      <Seo
        title="Terms & Conditions"
        description="The membership terms, booking rules and code of conduct for Kore Wellbeing Ltd, Bowness-on-Windermere."
        path="/terms"
      />
      <span className="eyebrow">Legal</span>
      <h1 className="display-1 mt-4 text-kore-forest">Terms &amp; Conditions</h1>
      <p className="mt-4 text-sm text-kore-ink/60">Last updated: February 2026</p>

      <div className="prose prose-lg mt-12 space-y-8 text-kore-ink/85 leading-relaxed font-light">
        <p>
          These terms apply to your membership of, and visits to, Kore Wellbeing Ltd ("Kore", "we", "us", "our") at Rowan House, Beresford Road, Bowness-on-Windermere, LA23 2JG. By joining as a member, purchasing a class, booking a consultation, or otherwise using our services, you agree to these terms.
        </p>

        <div>
          <h2 className="font-display text-3xl text-kore-forest mb-3">1. Membership</h2>
          <p>
            Membership is monthly and runs on a rolling basis with no minimum term unless stated otherwise. Membership fees are payable in advance by Direct Debit or card through our booking provider, TeamUp. You may cancel your membership at any time by giving one full calendar month's notice via your TeamUp account or by emailing us.
          </p>
        </div>

        <div>
          <h2 className="font-display text-3xl text-kore-forest mb-3">2. Bookings &amp; cancellations</h2>
          <ul className="mt-3 space-y-2 pl-6 list-disc marker:text-kore-gold">
            <li>Classes and coached sessions must be booked in advance via the TeamUp app or our website.</li>
            <li>Cancellations must be made at least <strong>4 hours</strong> before the session start time to avoid losing the booking credit.</li>
            <li>Late cancellations and no-shows may forfeit that session.</li>
            <li>We reserve the right to change or cancel sessions where necessary. Where possible we will provide notice in advance.</li>
          </ul>
        </div>

        <div>
          <h2 className="font-display text-3xl text-kore-forest mb-3">3. Drop-in payments &amp; refunds</h2>
          <p>
            One-off class drop-in payments are processed securely by Stripe. Drop-in bookings are non-refundable, but may be rescheduled at our discretion if you contact us before the class start time. If a session is cancelled by Kore, you will receive a full refund or a replacement booking.
          </p>
        </div>

        <div>
          <h2 className="font-display text-3xl text-kore-forest mb-3">4. Health &amp; safety</h2>
          <p>
            Training carries an inherent risk of injury. By using our facilities you confirm that:
          </p>
          <ul className="mt-3 space-y-2 pl-6 list-disc marker:text-kore-gold">
            <li>You are physically able to participate in the activities offered.</li>
            <li>You have disclosed any relevant medical conditions, injuries or pregnancies to your coach.</li>
            <li>You will follow the instructions of Kore coaches at all times.</li>
            <li>You use the equipment and facilities at your own risk and take reasonable care for your own safety.</li>
          </ul>
          <p className="mt-3">If you are unsure whether exercise is right for you, please consult your GP before joining.</p>
        </div>

        <div>
          <h2 className="font-display text-3xl text-kore-forest mb-3">5. Code of conduct</h2>
          <p>Kore is a small, considered community. We ask all members and guests to:</p>
          <ul className="mt-3 space-y-2 pl-6 list-disc marker:text-kore-gold">
            <li>Treat coaches, staff and fellow members with respect at all times.</li>
            <li>Return equipment after use and leave the facilities tidy.</li>
            <li>Arrive on time and be prepared for your session.</li>
            <li>Refrain from behaviour that could be considered aggressive, intimidating or discriminatory.</li>
          </ul>
          <p className="mt-3">We reserve the right to end a membership without refund if this code is repeatedly breached.</p>
        </div>

        <div>
          <h2 className="font-display text-3xl text-kore-forest mb-3">6. Personal belongings</h2>
          <p>Personal belongings brought onto the premises are your responsibility. Kore accepts no liability for loss or damage to personal property beyond what is required by law.</p>
        </div>

        <div>
          <h2 className="font-display text-3xl text-kore-forest mb-3">7. Photography &amp; media</h2>
          <p>Occasionally we take photographs or video within the club for marketing purposes. We will always ask for your consent before using any image in which you are identifiable. You can withdraw consent at any time by emailing us.</p>
        </div>

        <div>
          <h2 className="font-display text-3xl text-kore-forest mb-3">8. Opening hours</h2>
          <p>Open gym hours: Mon &amp; Wed 09:00 – 18:00. Tue &amp; Fri 09:00 – 14:00. Thu 11:00 – 18:00. Sat 08:30 – 14:00. Sun 08:30 – 12:00. Group coaching runs Mon–Fri from 06:00 (Mon, Tue, Wed &amp; Fri until 09:00; Thu until 11:00) plus Tue 19:00 – 20:00. Hours may change on bank holidays or for maintenance; we will provide notice via the app and website.</p>
        </div>

        <div>
          <h2 className="font-display text-3xl text-kore-forest mb-3">9. Changes to these terms</h2>
          <p>We may update these terms from time to time. Continued membership after any change constitutes acceptance of the revised terms.</p>
        </div>

        <div>
          <h2 className="font-display text-3xl text-kore-forest mb-3">10. Governing law</h2>
          <p>These terms are governed by the laws of England and Wales. Any disputes will fall under the exclusive jurisdiction of the English courts.</p>
        </div>

        <div>
          <h2 className="font-display text-3xl text-kore-forest mb-3">11. Contact</h2>
          <p>Questions about these terms? Email us at <a href="mailto:info@korewellbeing.com" className="text-kore-gold underline">info@korewellbeing.com</a>.</p>
        </div>
      </div>
    </article>
  );
}
